import importer from 'common/importer'
/* ALERT */
const alert = importer('Helpers/Alert')
export default function * failure ({ error }) {
  yield alert(
    'Register Error',
    error?.message || 'Please try again later'
  )
}
